import React from 'react';
import { css } from '@emotion/react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { color } from '@/styles';
import { RawGraphHintTooltip } from '../rawGraphHintTooltip';

const Container = css`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

const CheckBoxLabel = css`
  display: inline-flex;
  align-items: center;
  gap: 0 2px;
  color: ${color.dark_gray};
  font-size: 11px;
`;

const StyledFormControlLabel = css`
  display: flex;
  align-items: center;
  margin: 0;
  .MuiCheckbox-root {
    padding: 2px;
    user-select: none;
  }
`;

interface RawGraphCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const RawGraphCheckbox = React.memo(({ checked, onChange }: RawGraphCheckboxProps) => {
  const { t } = useTranslation();

  return (
    <div css={Container}>
      <FormControlLabel
        css={StyledFormControlLabel}
        disableTypography
        control={<Checkbox size='small' checked={checked} onChange={(_, nextChecked) => onChange(nextChecked)} />}
        label={
          <span css={CheckBoxLabel}>
            {t('rawGraph', '補正前グラフ')}
            <RawGraphHintTooltip />
          </span>
        }
      />
    </div>
  );
});
